namespace('IO.Views.PaymentDeviceTypes', function (exports) {
  'use strict';

  exports.Destroy = IO.Views.PaymentDeviceTypes.New;
});
